export const MOCKED_EXCHANGE_INSTANCE_ID = "fakeExchangeInstanceId";
